// Author: Sunil Jain
// Timestamp: 2025-04-16 15:35:00 PM EDT // Updated timestamp
// File: v4fe-physician/src/pages/NotFound.js
// Description: Placeholder component for the 404 Not Found page. (Corrected navigation)

import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // For navigation button

function NotFound() {
  const navigate = useNavigate();
  console.log("NotFound page rendered");

  const handleGoToCockpit = () => { // Renamed function for clarity
    console.log("NotFound: Navigating to /cockpit");
    navigate('/cockpit'); // Navigate to the main cockpit view
  };

  return (
    <Container component="main" maxWidth="sm"> {/* Smaller width for simple message */}
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center', // Center text
        }}
      >
        <Typography component="h1" variant="h3" gutterBottom>
          404
        </Typography>
        <Typography variant="h5" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Sorry, the page you are looking for does not exist or you do not have permission to access it.
        </Typography>
        {/* Corrected onClick handler and button text */}
        <Button variant="contained" onClick={handleGoToCockpit}>
          Go to Cockpit
        </Button>
      </Box>
    </Container>
  );
}

export default NotFound;